export default Object.freeze({
  // eslint-disable-next-line no-sequences
  MOBILE: (window.matchMedia('(max-device-width: 800px)').matches, window.matchMedia('(max-width: 800px)').matches)
})
